import { Link, useSearchParams, useSubmit } from "react-router-dom";
import { useRef } from "react";
import { ArrowRightStartOnRectangleIcon } from "@heroicons/react/24/solid";
import { useClickOutside } from "../../custom_hooks/ClickOutside";

function NavBar() {
  const submit = useSubmit();
  const [searchParams] = useSearchParams();
  const isDemo = Boolean(searchParams.get("demo")) || false;
  const detailsRef = useRef<HTMLDetailsElement | null>(null);
  useClickOutside([detailsRef], () => {
    if (detailsRef.current && detailsRef.current.open)
      detailsRef.current.open = false;
  });

  return (
    <div
      className={
        isDemo
          ? "hidden"
          : "navbar bg-base-100 sticky top-0 z-10 bg-opacity-90 backdrop-blur-sm shadow-xl w-full py-0"
      }
    >
      <div className="navbar-start"></div>
      <div className="navbar-center">
        <Link to="/" className="btn btn-ghost text-xl">
          My Gut Guide
        </Link>
      </div>
      <div className="navbar-end">
        <ul className="menu menu-horizontal px-1">
          {/* <li>
            <a>Item 1</a>
          </li> */}
          <li>
            <details ref={detailsRef}>
              <summary className="after:content-none flex content-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  className="inline-block w-5 h-5 stroke-current"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                  ></path>
                </svg>
              </summary>
              <ul className="p-2 end-0">
                <li>
                  <button
                    onClick={() => {
                      detailsRef.current!.open = false;
                      submit(null, { action: "/logout", method: "post" });
                    }}
                  >
                    <ArrowRightStartOnRectangleIcon className="h-5 w-5" />
                    Log out
                  </button>
                </li>
                {/* <li>
                  <a>Submenu 2</a>
                </li> */}
              </ul>
            </details>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default NavBar;
